import React, { useEffect } from "react";
import dashboardclasses from "../../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import swal from "sweetalert";
import {
    validateNegativeValues,
    validateEmptySpaces,
} from "../../../Components/utils/validations";
function AddCategory(props) {
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors },
    } = useForm();

    const watchFormData = watch();

    useEffect(() => {
        if (props.editable) {
            reset({
                ...props.editable,
                start_date: moment(props?.editable?.start_date).format(
                    "YYYY-MM-DD"
                ),
                end_date: moment(props?.editable?.end_date).format(
                    "YYYY-MM-DD"
                ),
            });
        }
        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };

    const onSubmit = (data) => {
        let form_Data = { ...data };

        if (!props.editable) {
            Services.addMobilityCoupon("POST", JSON.stringify(form_Data), token)
                .then((res) => {
                    console.log(res);
                    props.tableload(false);
                    if (res.Status === 1) {
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.tableload(true);
                        props.getCategories();
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        } else if (props.editable) {
            Services.updateMobilityCoupon(
                "PATCH",
                JSON.stringify(form_Data),
                token,
                props.editable?.coupon_code_id
            )
                .then((res) => {
                    console.log(res);
                    props.tableload(false);
                    if (res.Status === 1) {
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.getCategories();
                        props.setEditable(false);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        }
    };

    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>
                            {props.editable ? "Update Coupon" : "Add Coupon"}
                        </h3>
                        <p>
                            {props.editable ? "Update Coupon" : "Add Coupon"}{" "}
                            and necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Coupon Code</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="text"
                                {...register("coupon_code", {
                                    required: "Coupon Code is required",
                                    validate: validateEmptySpaces,
                                })}
                            />
                            {errors?.coupon_code && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.coupon_code?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    {/* <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Coupon Image</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={false}
                            handleChange={handleChange}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div> */}

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Coupon Type</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("type", {
                                    required: "Coupon Type is required",
                                })}>
                                <option value="1">Percentage</option>
                                <option value="2">Fixed</option>
                            </select>
                            {errors?.type && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.type?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    {/* <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Coupon Type</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("couponType", {
                                    required: "Coupon Type is required",
                                })}>
                                <option value="discount">Discount</option>
                                <option value="amount">Flat</option>
                            </select>
                            {errors?.couponType && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.couponType?.message}
                                </p>
                            )}
                        </div>
                    </div> */}
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Offer Value</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("offer_value", {
                                    required: "Offer value is required",
                                    validate: validateNegativeValues,
                                })}
                            />

                            {errors?.offer_value && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.offer_value?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Min Booking Value</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("min_booking_amount", {
                                    required: "Min Booking amount is required",
                                    validate: validateNegativeValues,
                                })}
                            />

                            {errors?.min_booking_amount && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.min_booking_amount?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Max Discount</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("max_discount", {
                                    required: "Max Discount is required",
                                    validate: validateNegativeValues,
                                })}
                            />

                            {errors?.max_discount && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.max_discount?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Start Date</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="date"
                                placeholder="dd-mm-yyyy"
                                {...register("start_date", {
                                    required: "Start Date is required",
                                })}
                            />

                            {errors?.start_date && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.start_date?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">End Date</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="date"
                                placeholder="dd-mm-yyyy"
                                {...register("end_date", {
                                    required: "End Date is required",
                                })}
                            />

                            {errors?.end_date && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.end_date?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Description</label>
                        <div className={dashboardclasses["select"]}>
                            <textarea
                                {...register("description", {
                                    required: "Description is required",
                                    validate: validateEmptySpaces,
                                })}
                                rows="4"></textarea>
                            {errors?.description && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.description?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="status">Status</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("status", {
                                    required: "status is required",
                                })}>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>
                            {errors?.status && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.status?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "update" : "Add Coupon"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
